module.exports = __webpack_public_path__ + "jab/media/report-selected.abe25448.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/report-selected.svg
// module id = 204
// module chunks = 0